import type { AuthStorage, TokenResponse } from "./types";

const KEY = "pfdn.auth.tokens";

export function createLocalStorage(): AuthStorage {
  return {
    getTokens: () => {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      try {
        return JSON.parse(raw) as TokenResponse;
      } catch {
        return null;
      }
    },
    setTokens: (tokens) => localStorage.setItem(KEY, JSON.stringify(tokens)),
    clear: () => localStorage.removeItem(KEY),
    // `storage` fires only in OTHER tabs, never the tab that made the change,
    // so this covers cross-tab clears; same-tab logout is handled by the store.
    onExternalClear: (handler) => {
      const listener = (event: StorageEvent) => {
        if (event.storageArea !== localStorage) return;
        if (event.key !== null && event.key !== KEY) return;
        if (event.newValue === null) handler();
      };
      window.addEventListener("storage", listener);
      return () => window.removeEventListener("storage", listener);
    },
  };
}
